import { ReactNode } from "react";

import styles from "./ProgressButton.module.scss";

type ProgressButtonProps = {
  children: ReactNode;
  onClick: () => void;
  progress: number;
  size?: number;
};

/**
 * Button surrounded by an SVG progress indicator
 */
export default function ProgressButton({
  children,
  onClick,
  progress,
  size = 64,
}: ProgressButtonProps) {
  const center = size / 2;
  const radius = center - 2;
  const dashArray = 2 * Math.PI * radius;
  const dashOffset = dashArray * ((100 - Math.max(progress, 1)) / 100);
  // Make sure progress is always at least `1` so the bar appears
  const strokeWidth = 4;

  return (
    <div className={styles.wrapper} style={{ width: size, height: size }}>
      <svg className={styles.indicator}>
        <circle
          cx={center}
          cy={center}
          fill="transparent"
          r={radius}
          stroke="currentColor"
          strokeDasharray={dashArray}
          strokeDashoffset={dashOffset}
          strokeLinecap="round"
          strokeWidth={strokeWidth}
        />
      </svg>

      <button
        className={styles.button}
        onClick={onClick}
        type="button"
        style={{
          width: `calc(100% - ${strokeWidth * 2}px)`,
          height: `calc(100% - ${strokeWidth * 2}px)`,
        }}
      >
        {children}
      </button>
    </div>
  );
}
